import React, { Component } from "react";
import { Modal } from "semantic-ui-react";
import "./loadingModal.css";

const WORKSPACE_MESSAGES = [
  "Precision optics start with careful preparation.",
  "Every lens tells a story of clarity and craft.",
  "Good vision is built one exact measurement at a time.",
  "Quality is never an accident — it is a habit.",
  "Clear sight, clear decisions.",
  "Small adjustments make a big difference in focus.",
  "Excellence in optics is attention to every micron.",
  "Your workspace is almost ready.",
];

class LoadingModal extends Component {
  state = {
    messageIndex: 0,
  };

  messageTimer = null;

  componentDidMount() {
    document.body.classList.add("workspace-loading-active");
    this.messageTimer = setInterval(() => {
      this.setState((prev) => ({
        messageIndex: (prev.messageIndex + 1) % WORKSPACE_MESSAGES.length,
      }));
    }, 3000);
  }

  componentWillUnmount() {
    document.body.classList.remove("workspace-loading-active");
    if (this.messageTimer) clearInterval(this.messageTimer);
  }

  getProgress = () => {
    const {
      loadingCustomerList,
      blankSelectionLoader,
      loadingFormData,
    } = this.props;

    const steps = [
      loadingCustomerList,
      blankSelectionLoader,
      loadingFormData,
    ].filter((flag) => flag !== undefined);

    if (!steps.length) return null;

    const total = steps.length;
    const done = steps.filter((flag) => !flag).length;
    // While modal is open, at least one is true — progress = completed of known steps
    const activeCount = steps.filter(Boolean).length;
    const completed = total - activeCount;
    return Math.max(8, Math.round((completed / total) * 100));
  };

  render() {
    const { messageIndex } = this.state;
    const progress = this.getProgress();
    const hasProgress = progress != null;

    return (
      <Modal
        open
        size="small"
        className="workspace-loading-modal"
        closeOnDimmerClick={false}
        closeOnEscape={false}
      >
        <Modal.Content className="workspace-loading-modal__content">
          <div className="workspace-loading">
            <div className="workspace-loading__lens-wrap" aria-hidden="true">
              <div className="workspace-loading__glow" />
              <div className="workspace-loading__lens">
                <span className="workspace-loading__lens-emoji">👓</span>
              </div>
            </div>

            <h2 className="workspace-loading__title">
              Preparing your workspace...
            </h2>

            <p
              key={messageIndex}
              className="workspace-loading__message"
            >
              {WORKSPACE_MESSAGES[messageIndex]}
            </p>

            <div
              className={`workspace-loading__bar${
                hasProgress ? "" : " is-indeterminate"
              }`}
              role="progressbar"
              aria-valuemin={0}
              aria-valuemax={100}
              aria-valuenow={hasProgress ? progress : undefined}
              aria-label="Loading progress"
            >
              <div
                className="workspace-loading__bar-fill"
                style={hasProgress ? { width: `${progress}%` } : undefined}
              />
            </div>
          </div>
        </Modal.Content>
      </Modal>
    );
  }
}

export default LoadingModal;
